import type {DateRangeValueEditorLocalizations, DateRangeValueEditorOptions} from './types';
import type {DefaultOptions} from '../../../types';

export const DATE_RANGE_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<DateRangeValueEditorOptions> = {
    granularity: 'date-only',
    compact: false
};

export const DATE_RANGE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<DateRangeValueEditorLocalizations>({
    description: '',
    openRangeSelector: 'Open range selector',
    selectedRange: 'Selected range:',
    from: 'From',
    to: 'To'
});